import {
  faAward,
  faFire,
  faMedal,
  faMoon,
  faPowerOff,
  faScaleBalanced,
  faStar,
  faTriangleExclamation,
  faTrophy,
  faUser,
  type IconDefinition,
} from "@fortawesome/free-solid-svg-icons";

export const segmentIcons: Record<string, IconDefinition> = {
  Critical: faFire,
  Loyalist: faMedal,
  Champion: faTrophy,
  "At risk": faTriangleExclamation,
  Average: faScaleBalanced,
  "Potential loyalist": faStar,
  Hibernating: faPowerOff,
  "About to sleep": faMoon,
  Promising: faAward,
  New: faUser,
};
